"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.shared.title': 'Conversazioni condivise',
    'reports.shared.description': 'Visualizza conversazioni che sono state condivise con te da altri utenti',
    'reports.shared.failedToLoad': 'Impossibile caricare conversazioni condivise',
    'reports.shared.retryButton': 'Riprova',
    'reports.shared.empty.title': 'Nessuna conversazione condivisa',
    'reports.shared.empty.description': 'Non hai ancora conversazioni condivise da altri utenti.',
    'reports.shared.createdAt': 'Creato',
    'reports.shared.lastActivity': 'Ultima attività',
    'reports.shared.model': 'Modello IA',
    'reports.shared.unknownModel': 'Modello sconosciuto',
    'reports.shared.unknownUser': 'Utente sconosciuto',
    'reports.shared.viewButton': 'Visualizza',
    'reports.shared.sharedWith': 'Condiviso con',
    'reports.shared.noUsers': 'Nessun utente',
};
